import _uniqueId from "lodash/uniqueId";
import _omit from "lodash/omit";
import _isFunction from "lodash/isFunction";
import _defer from "lodash/defer";
import { Component } from 'react';
import { CSSUtils, KeyUtils } from '../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class Collapsible extends Component {
  body = null;
  wrapper = null;
  static displayName = 'Collapsible';
  static defaultProps = {
    animate: true
  };
  static getDerivedStateFromProps = (props, state) => {
    const prevProps = state.prevProps || {};
    if (props.expanded === prevProps.expanded) {
      return null;
    }
    if (props.expanded !== state.expanded) {
      return {
        expanded: props.expanded,
        collapsing: state.expanded,
        prevProps: props
      };
    }
    return null;
  };
  state = {
    collapsing: false,
    uniqueId: _uniqueId('collapsible-'),
    expanded: !!this.props.expanded
  };
  componentDidMount() {
    if (!this.state.expanded) {
      ;
      this.wrapper.style.height = 0 + 'px';
    } else {
      ;
      this.wrapper.style.overflow = 'visible';
    }
    if (!this.canAnimate()) {
      return;
    }
    CSSUtils.events.transition.onEnd(this.wrapper, this.handleTransitionEnd);
  }
  getSnapshotBeforeUpdate(_, prevState) {
    if (!this.wrapper) {
      return null;
    }
    if (prevState.expanded && !this.state.expanded) {
      return this.getBodyHeight() + 'px';
    }
    return null;
  }
  componentDidUpdate(_, prevState, snapshot) {
    if (!this.wrapper) {
      return;
    }
    if (prevState.expanded === this.state.expanded) {
      return;
    }
    if (snapshot) {
      this.wrapper.style.height = snapshot;
    }

    //@ts-ignore legacy
    this.wrapper.style.overflow = null;
    if (this.state.expanded) {
      this.wrapper.style.height = this.getHeight() + 'px';
    } else {
      this.wrapper.style.height = this.getBodyHeight() + 'px';
      _defer(() => this.wrapper.style.height = '0px');
    }
    if (!this.canAnimate()) {
      this.handleTransitionEnd();
    }
  }
  componentWillUnmount() {
    if (!this.canAnimate()) {
      return;
    }
    CSSUtils.events.transition.offEnd(this.wrapper, this.handleTransitionEnd);
  }
  handleTransitionEnd = (event = {}) => {
    if (this.canAnimate() && event.target !== this.wrapper) {
      return;
    }
    const {
      expanded
    } = this.state;
    const {
      onExpanded,
      onCollapse
    } = this.props;
    if (!expanded) {
      this.setState({
        collapsing: false
      });
      if (onCollapse) {
        onCollapse();
      }
      return;
    }
    if (expanded && onExpanded) {
      onExpanded();
    }
    if (expanded) {
      ;
      this.wrapper.style.overflow = 'visible';
    }

    //@ts-ignore legacy
    this.wrapper.style.height = null;
  };
  getHeight = () => {
    if (!this.state.expanded) {
      return 0;
    }
    return this.getBodyHeight();
  };
  getBodyHeight = () => {
    return this.body ? this.body.offsetHeight : 0;
  };
  canAnimate() {
    return this.props.animate && CSSUtils.events.transition.possible();
  }
  render() {
    var {
      className = '',
      header,
      animate,
      children,
      onToggle,
      onBeforeCollapse,
      onCollapse,
      onExpand,
      expanded: expandedProp,
      preventToggle,
      ...rest
    } = this.props;
    const {
      expanded,
      collapsing,
      uniqueId
    } = this.state;
    var cls = CSSUtils.cls({
      collapsible: true,
      'collapsible-expanded': expanded,
      'collapsible-in-collapse': collapsing
    }, className);
    return /*#__PURE__*/_jsxs("div", {
      ..._omit(rest, 'onExpanded'),
      className: cls,
      children: [/*#__PURE__*/_jsx("div", {
        className: "collapsible-header",
        "aria-controls": uniqueId,
        "aria-label": "Toggle collapsible",
        "aria-expanded": expanded,
        tabIndex: 0,
        role: "button",
        onKeyDown: ev => {
          if (KeyUtils.isEnter(ev) || KeyUtils.isSpace(ev)) {
            ev.preventDefault();
            this.toggleCollapse(ev);
          }
        },
        onClick: this.toggleCollapse,
        children: _isFunction(header) ? header(expanded) : header
      }), /*#__PURE__*/_jsx("div", {
        ref: node => this.wrapper = node,
        className: "collapsible-wrapper clearfix",
        children: (expanded || collapsing) && /*#__PURE__*/_jsx("div", {
          ref: node => this.body = node,
          className: "collapsible-body",
          id: uniqueId,
          children: /*#__PURE__*/_jsx("div", {
            className: "collapsible-content",
            children: this.props.children
          })
        })
      })]
    });
  }
  toggleCollapse = ev => {
    if (this.props.preventToggle) {
      return;
    }
    if (this.props.onToggle) {
      this.props.onToggle(!this.state.expanded, ev);
    }
    if (!this.state.expanded) {
      if (this.props.onExpand) {
        this.props.onExpand(ev);
      }
    } else {
      if (this.props.onBeforeCollapse) {
        this.props.onBeforeCollapse(ev);
      }
    }
    this.setState({
      expanded: !this.state.expanded,
      collapsing: this.state.expanded
    });
  };
}